<template>
	<div class="menu-content-container display-flex flex-column width-100 pt-5 flex-justify-space-between">
		<div class="display-flex flex-column top-section pl-4">
			<div class="display-flex flex-row flex-align-center flex-justify-space-between pr-7 mb-3">
				<div class="title-text text-align-left">Add apps</div>
				<AnemicButton @click="openSettingsDialog" tile class="px-1 manage-button">
					<SIcon class="mr-2" name="manage-my-apps" width="12" height="14" />
					Manage my apps
				</AnemicButton>
			</div>
			<SelectFavoriteAppsMenuSearch ref="search" class="pr-7 mb-3" :searchString.sync="searchString" />
			<CurrentSelectedApps
				class="pr-7"
				@remove-app="removeApp"
				v-if="currentSelectedApps.length > 0"
				:currentSelectedApps="currentSelectedApps"
			/>
			<AllAppsMenu @select-app="selectApp" :currentSelectedApps="currentSelectedApps" :searchString="searchString" class="pr-3 mt-3" />
		</div>
		<div class="footer-container flex-centerize">
			<AnemicButton :disabled="isSaveButtonDisabled" :loading="isLoading" @click="addSelectedApps" class="add-button" tile>
				Add selected
			</AnemicButton>
		</div>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
import AllAppsMenu from '@/components/SelectFavoriteApps/AllAppsMenu.vue';
import CurrentSelectedApps from '@/components/SelectFavoriteApps/CurrentSelectedApps.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import SelectFavoriteAppsMenuSearch from '@/components/SelectFavoriteApps/SelectFavoriteAppsMenuSearch.vue';
export default {
	name: 'SelectFavoriteAppsMenuContent',
	components: {
		AllAppsMenu,
		CurrentSelectedApps,
		SelectFavoriteAppsMenuSearch,
	},
	computed: {
		isSaveButtonDisabled() {
			return this.isLoading || this.currentSelectedApps.length === 0;
		},
	},
	methods: {
		...mapActions(['saveFavoriteApps']),
		selectApp(app) {
			this.currentSelectedApps = [...this.currentSelectedApps, app];
			this.searchString = '';
			this.$refs.search?.focus();
		},
		removeApp(app) {
			this.currentSelectedApps = this.currentSelectedApps.filter((selectedApp) => selectedApp.id !== app.id);
		},
		async addSelectedApps() {
			const idsToMarkAsFavorite = this.currentSelectedApps.map(({ id }) => id);
			this.isLoading = true;
			try {
				await this.saveFavoriteApps({ favoriteAppsIds: idsToMarkAsFavorite });
				this.searchString = '';
				this.currentSelectedApps = [];
			} catch {
				this.$toast.error('Failed saving favorite apps. please try again later');
			} finally {
				this.isLoading = false;
			}
		},
		openSettingsDialog() {
			AppDialogManagerService.openSettingsDialog({ routeName: 'ManageApps' });
		},
	},
	data() {
		return {
			searchString: '',
			isLoading: false,
			currentSelectedApps: [],
		};
	},
};
</script>
<style lang="scss" scoped>
.menu-content-container {
	width: 480px;
	height: 460px;
}
.title-text {
	font-size: 18px;
	font-weight: medium;
	color: var(--primary-font-color);
}
.footer-container {
	min-height: 72px;
	border: 1px solid #abb2bd6e;
	border-radius: 0px 0px 10px 10px;
	box-shadow: 0px -1px 2px #80899c4d;
}
.add-button {
	height: 45px !important;
	font-size: 16px !important;
	padding: 0px 14px !important;
	border-radius: 10px !important;
	font-weight: normal !important;
	color: var(--white) !important;
	background: #605ed9 !important;
	letter-spacing: 0.21px !important;
}
.top-section {
	overflow: hidden;
}
.manage-button {
	height: 25px !important;
	font-size: 12px !important;
	border-radius: 4px !important;
	font-weight: normal !important;
	letter-spacing: 0.16px !important;
	background: var(--white) !important;
	border: 1px solid #dfdfe2 !important;
	color: var(--primary-font-color) !important;
}
</style>
